/**
 * Shared utilities for ShippingDocumentsDialog
 * Used by both the Client app and BCC admin application.
 */

export {
  getBatchSize,
  processAllLabelUrlBatches,
  processBatch,
  processBatchResults,
  processLabelUrlBatch,
  type BulkShippingLabelUrlsFn,
  type OrderId,
} from "./batchUtils";
export { generateCacheKey } from "./cacheKeyUtils";
export { createOrdersCacheKey, yieldCachedUrls, type CachedLabelUrlEntry } from "./cacheUtils";
export { clearError, extractErrorMessage, getErrorStatusCode, isRetryableError } from "./errorUtils";
export {
  buildCachedLabelUrlMap,
  buildOrderBatches,
  getCachedLabelUrls,
  isLabelUrlEntryFresh,
  maybeClearExpiredCachedLabelUrls,
  PRESIGNED_URL_REFRESH_BUFFER_MS,
  shouldRefreshPresignedLabelUrlsForError,
} from "./labelUrlFetching";
export { getPackingSlipOptions, type PackingSlipConfigParams, type PackingSlipOptions } from "./packingSlipUtils";
export { createInterleavedSequence, createOrderIndexMap } from "./pdfGeneration";
export { createSerializedAddPage, createSerializedFitPdfInMemory, isAborted, processLabelAndSlipForCombined } from "./pdfProcessingUtils";
export type { FitPdfInMemoryFn } from "./pdfProcessingUtils";
export { fillUrlQueue, processUrlsWithConcurrency, startNewFetches, type UrlItem } from "./streamingUtils";
export {
  buildTabs,
  getInitialTab,
  shouldShowGroupBy,
  shouldShowManifest,
  type BuildTabsParams,
  type CarrierDetails,
  type TabItem,
} from "./tabConfig";
